// src/pages/UserLogin/UserLogin.jsx
import { useState, useContext } from "react";
import axios from "axios";
import "./UserLogin.css";
import { AuthContext } from "../../context/AuthContext";
import { COPY, useToast } from "../../context/ToastContext";
import { useNavigate } from "react-router-dom";

function UserLogin() {
  // For students, we're using studentID and name for login.
  const [studentID, setStudentID] = useState("");
  const [name, setName] = useState("");

  // Use setAuthState (which expects an object with isAuthenticated and role)
  const { setAuthState } = useContext(AuthContext);
  const { toast } = useToast();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      // Post credentials to the student login endpoint
      await axios.post(
        `/api/student?action=login`,
        { studentID, name },
        { withCredentials: true }
      );

      // On success, mark the user as authenticated with the "student" role.
      setAuthState({ isAuthenticated: true, role: "student" });
      toast.success("Welcome back! You're signed in.");
      navigate("/signedInStudent");
    } catch (error) {
      console.error("Login error:", error);

      // Branch on status rather than the server's message text, and never echo
      // that text into the toast.
      if (!error.response) {
        toast.error(COPY.unreachable);
      } else if (error.response.status === 401) {
        toast.error("That Student ID or name didn't match. Give it another try.");
      } else if (error.response.status === 400) {
        toast.warning("Please enter both your Student ID and your name.");
      } else if (error.response.status === 429) {
        toast.warning(COPY.rateLimited);
      } else {
        toast.error(COPY.serverError);
      }
    }
  };

  return (
    <div className="user-login-container">
      <form className="user-login-form" onSubmit={handleLogin}>
        <h2>User Login</h2>
        <label>
          Student ID:
          <input
            type="text"
            value={studentID}
            onChange={(e) => setStudentID(e.target.value)}
            required
          />
        </label>
        <br />
        <label>
          Name:
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </label>
        <br />
        <button type="submit">Login</button>
      </form>
    </div>
  );
}

export default UserLogin;
